import { ModalText } from './types';
import { clipLastSegmentRoute, getResourceNameFromPath } from '../../utility/path';


export const getPreventLeaveText = (): ModalText => {
  const resource = getResourceNameFromPath();

  return {
    title: 'Are you sure you want to leave?',
    message: `Choosing leave without saving will discard all of your changes to this ${resource}?`,
    cancelText: 'Leave',
    approveText: 'Stay',
  };
};

export const getPreventCancelText = (): ModalText => {
  const resource = getResourceNameFromPath();

  return {
    title: 'Are you sure you want to discard changes?',
    message: `Choosing cancel will discard all of your changes to this ${resource}`,
    cancelText: 'Yes, cancel',
    approveText: 'No, continue',
  };
};

export const checkChangeResource = (currentRoute: string, nextRoute: string): boolean => {
  const segmentsWithSoftChecking = [
    'video-menus',
  ];

  if (segmentsWithSoftChecking.some((segment) => currentRoute.indexOf(segment) !== -1)) {
    if (nextRoute.indexOf(currentRoute) !== -1 || nextRoute.indexOf(clipLastSegmentRoute(currentRoute)) !== -1) {
      return false;
    }
  }

  return currentRoute !== nextRoute;
};
